import { format } from "date-fns";
import moment from "moment";
import React, { useEffect, useState } from "react";

import * as Styles from "../../styles";

import "moment/locale/pt-br";

interface Props {
  className?: string;
  type: string;
  dataNotificacao: string;
  textNotificacao: string;
  idLeadCorretor: string;
  setModalNotifications: Function;
}

const CardNotifications: React.FC<Props> = ({
  className,
  type,
  dataNotificacao,
  textNotificacao,
  idLeadCorretor,
  setModalNotifications,
}) => {
  const [timeNotification, setTimeNotification] = useState<string>("");
  const [typeTitle, setTypeTitle] = useState<string>("");

  useEffect(() => {
    calcTime();

    switch (type) {
      case "TransferenciaLead":
        setTypeTitle("Transferência!");
        break;
      case "CompartilhamentoLead":
        setTypeTitle("Compartilhamento!");
        break;
      case "RemocaoCompartilhamento":
        setTypeTitle("Compartilhamento!");
        break;
      case "Tarefa24HorasAntesRealizacao":
        setTypeTitle("Tarefas!");
        break;
      case "Tarefa15MinutosAntesRealizacao":
        setTypeTitle("Tarefas!");
        break;
      case "Tarefa2HorasAntesRealizacao":
        setTypeTitle("Tarefas!");
        break;
      case "TarefaAtrasada":
        setTypeTitle("Tarefas!");
        break;
      case "aniversarioLead":
        setTypeTitle("Aniversário!");
        break;
      case "SolicitacaoVisita":
        setTypeTitle("Tarefas!");
        break;
      default:
        break;
    }
  }, []);

  const calcTime = () => {
    const today: any = new Date();
    const notificationDate: any = new Date(dataNotificacao);
    const diferenceDays = today - notificationDate;

    const todayDiference = moment(dataNotificacao).locale("pt-br").fromNow();

    if (diferenceDays > 0) {
      if (diferenceDays === 1) {
        setTimeNotification("Ontem");
      } else {
        setTimeNotification(format(notificationDate, "dd/MM/yyyy : HH:mm"));
      }
    } else {
      setTimeNotification(todayDiference);
    }
  };

  const clickAction = (type: string) => {
    switch (type) {
      case "Tarefa24HorasAntesRealizacao":
        // @ts-ignore
        document.querySelector(".tasks-today").click();
        setModalNotifications(false);
        break;
      case "TarefaAtrasada":
        // @ts-ignore
        document.querySelector(".tasks-late").click();
        setModalNotifications(false);
        break;
      case "RemocaoCompartilhamento":
        console.log("Remocao compartilhamento");
        break;
      default:
        window.location.href = `/lead-detail/${idLeadCorretor}`;
        break;
    }
  };

  return (
    <Styles.CardNotifications
      onClick={() => clickAction(type)}
      className={className}
    >
      <Styles.HeaderCardNotifications>
        <Styles.TitleHeaderCardNotifications className={className}>
          {typeTitle}
        </Styles.TitleHeaderCardNotifications>
        <Styles.DateHeaderCardNotifications>
          {timeNotification}
        </Styles.DateHeaderCardNotifications>
      </Styles.HeaderCardNotifications>
      <Styles.ContentNotifications>
        {textNotificacao}
      </Styles.ContentNotifications>
    </Styles.CardNotifications>
  );
};

export default CardNotifications;
